import React, {useEffect, useLayoutEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {injectIntl} from 'react-intl';

import {toggleShowDescriptionCover} from "../../actions/actionFunctions";
import {wizardGroupInterface} from "../../interfaces/wizardItemInterface";
import {useIsMounted, usePrevious} from "../../misc/helperHooks";
import {getFeatureGroupDescription} from "../look/grohe/groheNavigation/groheFunctions";

let timeoutId = 0;

const SelectionDescriptionCover = (props) => {

  const {activePart, wizardGroup, intl, showDescriptionCover, toggleShowDescriptionCover, windowWidth,
    fabricatorData, bvOpened} = props;

  const isMounted = useIsMounted();
  const prevWizardGroup = usePrevious(wizardGroup);
  const prevActivePart = usePrevious(activePart);
  const prevBvOpened = usePrevious(bvOpened);
  const [coverText, setCoverText] = useState("");

  const getDescriptionText = () => {
    if (wizardGroup && wizardGroup.description) {
      return wizardGroup.description
    }
    if (!activePart) {
      return ""
    }
    return getFeatureGroupDescription(activePart.part, intl, fabricatorData)
  };

  const showCover = () => {
    clearTimeout(timeoutId);
    toggleShowDescriptionCover(false);
    timeoutId = setTimeout(() => {
      const descText = getDescriptionText();
      if (isMounted() && descText) {
        setCoverText(descText);
        toggleShowDescriptionCover(true);
      }
    }, 2000);
  }

  // showDescriptionCover lives in Redux, so it survives this component
  // unmounting/remounting (e.g. navigating materials -> cart -> materials).
  // Reset it to hidden *before paint* (useLayoutEffect, not useEffect) so a
  // stale "true" left over from before unmount can't flash an empty cover
  // open before showCover() closes it again.
  useLayoutEffect(() => {
    clearTimeout(timeoutId);
    setCoverText("");
    toggleShowDescriptionCover(false);

    return () => {
      clearTimeout(timeoutId);
      toggleShowDescriptionCover(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (bvOpened) {
      // visualizer is open over the selection window - keep the cover hidden
      clearTimeout(timeoutId);
      toggleShowDescriptionCover(false);
    } else if (prevBvOpened && !bvOpened) {
      // visualizer just closed - roll the cover out the same way a group change does
      showCover();
    } else if (!prevWizardGroup && wizardGroup || (prevWizardGroup && wizardGroup && (prevWizardGroup.id !== wizardGroup.id))) {
      showCover();
    } else if (!prevActivePart && activePart || (prevActivePart && activePart && (prevActivePart.part.partName !== activePart.part.partName))) {
      showCover();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePart, wizardGroup, bvOpened]);

  let styles = {};
  if (coverText && (coverText.length > 250) && (windowWidth < 991)) {
    styles = windowWidth < 640
      ? {fontSize: "10px"}
      : windowWidth < 800 ? {fontSize: "13px"} : {}
  }

  return (
    <div className={"cover" + (showDescriptionCover ? " cover--active" : "")} style={styles}>
      {coverText}
      <button className="ui-close" onClick={() => toggleShowDescriptionCover(false)}/>
    </div>
  )
}

SelectionDescriptionCover.propTypes = {
  activePart: PropTypes.object,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
};

const mapStateToProps = (store) => {
  return {
    showDescriptionCover: store.selectionState.showDescriptionCover,
    windowWidth: store.serverState.windowWidth,
    fabricatorData: store.fabricatorState,
    bvOpened: store.bathroomVisualizerState.bvOpened,
  };
};

const mapDispatchToProps = {
  toggleShowDescriptionCover
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SelectionDescriptionCover)
)
